import React from 'react';
import { connect } from 'react-redux';
import HeaderFilter from './HeaderFilter';
import AdminMenu from './AdminMenu';

const HeaderBlock = props => {
  const { adminNav, user, displayNewForm } = props;

  return (
    <div style={styles.container}>
      <div style={styles.header}>Admin screen</div>
      <AdminMenu />

      <div style={styles.buttonsContainer}>
        {adminNav === 'customers' && (user.bRole === 1 ? <button style={styles.button} onClick={displayNewForm}>+ Customer</button> : <div style={styles.empty}></div>)}
        {adminNav === 'sites' && <button style={styles.button} onClick={displayNewForm}>+ Site</button>}
        {adminNav === 'devices' && <div style={styles.empty}></div>}
        {adminNav === 'cameras' && <div style={styles.empty}></div>}
        {adminNav === 'views' && <button style={styles.button} onClick={displayNewForm}>+ View</button>}
        {adminNav === 'users' && <button style={styles.button} onClick={displayNewForm}>+ User</button>}
      </div>

      <HeaderFilter {...props} />
    </div>
  )
}

const mapStateToProps = state => {
  const { adminNav } = state.config
  const { user } = state.auth
  return { adminNav, user }
}

export default connect(mapStateToProps)(HeaderBlock)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1vmin',
    margin: '0 1%',
    height: '18vmin',
  },
  header: {
    fontSize: '3.2vmin',
    fontWeight: 'bold',
  },
  buttonsContainer: {
    width: '48%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  button: {
    padding: '.5vmin',
    cursor: 'pointer',
    borderRadius: 5,
    fontSize: '1.6vmin',
    paddingLeft: '2vmin',
    paddingRight: '2vmin',
    height: '4vmin',
  },
  empty: {
    height: '4vmin',
  },
}